import widgets from '@/plugins/dashboard/widgets'

export const WIDGETS = widgets

export const DEFAULT_DASHBOARD = {
  layout: [
    { 'x': 0, 'y': 0, 'w': 6, 'h': 11, 'i': '76698041-fe1a-4245-801c-9cfde4c337c7' }
  ],
  widgets: {
    '76698041-fe1a-4245-801c-9cfde4c337c7': {
      name: 'Consignments',
      configuration: {
        title: 'Consignments By State',
        chartType: 'Line',
        isResizable: true,
        timeBreakDown: 'Week',
        report: 'FreightSummaryBranch',
        xKey: 'State',
        yKey: 'Connotes',
        params: {
          weekBreakDown: true,
          dateFrom: 'month',
          dateTo: 'today',
          state: true
        }
        // stack: [
        //   {
        //     name: 'Items',
        //     configuration: {
        //       title: 'Items By State',
        //       chartType: 'Bar',
        //       isResizable: true,
        //       report: 'FreightSummaryBranch',
        //       xKey: 'State',
        //       yKey: 'No Items',
        //       params: {
        //         dateFrom: '2018-05-25',
        //         dateTo: '2018-06-25',
        //         state: true
        //       }
        //     }
        //   }
        // ]
      }
    }
  }
}

export { default } from '@/plugins/dashboard/components/Dashboard'
